import { environment,ENV_CONSTANTS } from '@env-properties/environment';

class GlobalClass {

  public ENV_NAME:any;

  constructor(){
    this.ENV_NAME = ENV_CONSTANTS.environmentsNames[environment.baseUrl];
  }

}

export const GlobalClassInstance = new GlobalClass();

